module.exports = "../dist/img/product-detail-4-30.9164.jpg";